/**
 * OOI-specific experiments should be listed here.
 * scope: viewer-apps-14bcded7-0066-7c35-14d7-466cb3f09103
 */
export const OOI_EXPERIMENTS = {
  /**
   * Does not allow to install blog members area apps in the editor.
   * https://bo.wix.com/guineapig/experiments/4288493
   */
  DONT_REGISTER_MEMBER_PAGES: 'specs.wixBlog.DontRegisterMemberPages',
  /**
   * Stops registering and installing OOI Members Area pages on Studio 2, where Members Area
   * moves to Builder pages that come in through the installation extension.
   */
  SKIP_MEMBERS_AREA_OOI_PAGES_IN_STUDIO2: 'skipMembersAreaOoiPagesInStudio2',
  USE_LAYOUT_FIXER: 'specs.wixBlog.UseLayoutFixer',
  HASHTAG_PAGE_USE_FEED_PAGE: 'specs.wixBlog.HashtagPageUseFeedPage',
  /**
   * Whether the site is on Nile.
   */
  DRAFT_POST_PROXY_NILE_ROUTING: 'draftPostProxyNileRoutingExperiment',
  /**
   * Resolve post paywalls through blog-paywall-service instead of paywall-server, which makes the
   * paywall a property of the post rather than one default banner per site.
   */
  NEW_BLOG_MONETIZATION_EXPERIENCE: 'newBlogMonetizationExperience',
  /**
   * Enables the category header baked into the Blog widget on new installations.
   */
  OOI_CATEGORY_HEADER_BLOG: 'ooiCategoryHeaderBlog',
} as const;
